import * as yup from 'yup';

export const loginValidation = yup.object({
  email: yup.string().required('*required').email(),
  password: yup.string().required('*required').min(6)
});
